import { PartialType } from '../../../../utils';
import { CreateVehicleModelOptionDto } from '../create';
export class UpdateVehicleModelOptionDto extends PartialType(CreateVehicleModelOptionDto) {
}
